import * as CapitalMuiTheme_Theme_components_dataDisplay_MuiAvatar from "./MuiAvatar.js";
import * as CapitalMuiTheme_Theme_components_dataDisplay_MuiBadge from "./MuiBadge.js";
import * as CapitalMuiTheme_Theme_components_dataDisplay_MuiChip from "./MuiChip.js";
import * as CapitalMuiTheme_Theme_components_dataDisplay_MuiDataGrid from "./MuiDataGrid.js";
import * as CapitalMuiTheme_Theme_components_dataDisplay_MuiDivider from "./MuiDivider.js";
import * as CapitalMuiTheme_Theme_components_dataDisplay_MuiList from "./MuiList.js";
import * as CapitalMuiTheme_Theme_components_dataDisplay_MuiMenu from "./MuiMenu.js";
import * as CapitalMuiTheme_Theme_components_dataDisplay_MuiTable from "./MuiTable.js";
import * as CapitalMuiTheme_Theme_components_dataDisplay_MuiTooltip from "./MuiTooltip.js";
import * as CapitalMuiTheme_Theme_components_dataDisplay_MuiTypography from "./MuiTypography.js";
const dataDisplay = {
  ...CapitalMuiTheme_Theme_components_dataDisplay_MuiChip,
  ...CapitalMuiTheme_Theme_components_dataDisplay_MuiDivider,
  ...CapitalMuiTheme_Theme_components_dataDisplay_MuiList,
  ...CapitalMuiTheme_Theme_components_dataDisplay_MuiTypography,
  ...CapitalMuiTheme_Theme_components_dataDisplay_MuiTable,
  ...CapitalMuiTheme_Theme_components_dataDisplay_MuiDataGrid,
  ...CapitalMuiTheme_Theme_components_dataDisplay_MuiBadge,
  ...CapitalMuiTheme_Theme_components_dataDisplay_MuiMenu,
  ...CapitalMuiTheme_Theme_components_dataDisplay_MuiTooltip,
  ...CapitalMuiTheme_Theme_components_dataDisplay_MuiAvatar
};
export {
  dataDisplay
};
//# sourceMappingURL=index.js.map
